// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"pp-z","slideIn":"qp-z"};